import { useEffect, useState } from 'react';

const Permission = ({ allowedPermission, children }) => {
	const [userPermissions, setUserPermissions] = useState([]);
	useEffect(() => {
		let userInfo = localStorage.getItem('userInfo');
		if (userInfo) {
			userInfo = JSON.parse(userInfo);
			setUserPermissions([...(userInfo?.permissions || [])]);
		}
	}, []);
	const couldShow = allowedPermission.filter((permission) =>
		userPermissions.some((userPermission) => userPermission === permission)
	);
	return couldShow?.length > 0 ? children : null;
};
export default Permission;
